module.exports = __webpack_public_path__ + "static/media/icon-likes-green.c97e6d40.svg";